import { scrollToElementWithStickyOffset } from "../../../common/js/helpers"

export default () => ({
  init() {
    this.store = Alpine.store("data")
  },

  getPricePerPeriod() {
    return this.store.pricing.getPricePerPeriod({
      offer: this.store.values.activeOffer,
      isChance: this.store.values.exitIntent,
    })
  },

  handleDiscountButtonClick() {
    this.store.internalTracker.trackClick({ clickName: "Anchor 1 Clicked" })
    document.getElementById("selectPlanTitle").scrollIntoView({ behavior: "smooth" })
  },

  handleDiscountButtonClickWithOffset() {
    this.store.internalTracker.trackClick({ clickName: "Anchor 1 Clicked" })
    scrollToElementWithStickyOffset({ targetSelector: "#offer-container", stickySelector: "#sticky-top-banner", offset: 12 })
  },

  isExitIntentUiApplied() {
    return this.store.values.exitIntent && this.store.values.activeOffer.type.toLowerCase() === 'basic'
  },
})
